import React from 'react';
import FadeIn from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiVideo, FiClock, FiShield } from 'react-icons/fi';

export default function Solution() {
  const features = [
    { icon: FiVideo, title: "Short, Actionable Videos", desc: "No fluff. Just clear steps to take right now." },
    { icon: FiClock, title: "Fast Implementation", desc: "Designed to give you immediate relief and visibility." },
    { icon: FiShield, title: "Shame-Free Zone", desc: "A calm, reassuring approach to your finances." }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 max-w-7xl mx-auto">
      <FadeIn>
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">The 7-Day Bill Panic Reset</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">A simple, guided process to stop the bleeding and find solid ground.</p>
        </div>
        
        <div className="relative mb-20">
          <div className="aspect-video max-w-4xl mx-auto rounded-3xl overflow-hidden shadow-2xl relative group">
            <img 
              src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&q=80&w=1200" 
              alt="Course on laptop" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-slate-900/40 flex items-center justify-center">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border border-white/30 group-hover:scale-110 transition-transform cursor-pointer">
                <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <SafeIcon icon={FiVideo} className="text-blue-600 text-2xl" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <div key={idx} className="flex flex-col items-center text-center p-8 rounded-2xl bg-slate-50 hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300">
              <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-6 rotate-3">
                <SafeIcon icon={feature.icon} className="text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </FadeIn>
    </section>
  );
}